import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { SubscriptionTypeComponent } from './subscription-type.component';
import { SubscriptionTypeDetailComponent } from './subscription-type-detail.component';
import { SubscriptionTypePopupComponent } from './subscription-type-dialog.component';
import { SubscriptionTypeDeletePopupComponent } from './subscription-type-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class SubscriptionTypeResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const subscriptionTypeRoute: Routes = [
    {
        path: 'subscription-type',
        component: SubscriptionTypeComponent,
        resolve: {
            'pagingParams': SubscriptionTypeResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.subscriptionType.home.title'
        }
    }, {
        path: 'subscription-type/:id',
        component: SubscriptionTypeDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.subscriptionType.home.title'
        }
    }
];

export const subscriptionTypePopupRoute: Routes = [
    {
        path: 'subscription-type-new',
        component: SubscriptionTypePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.subscriptionType.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'subscription-type/:id/edit',
        component: SubscriptionTypePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.subscriptionType.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'subscription-type/:id/delete',
        component: SubscriptionTypeDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.subscriptionType.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/subscription-type/subscription-type.route.ts